import { render, staticRenderFns } from "./IV04.vue?vue&type=template&id=70900d4f"
import script from "./IV04.vue?vue&type=script&lang=js"
export * from "./IV04.vue?vue&type=script&lang=js"
import style0 from "./IV04.vue?vue&type=style&index=0&id=70900d4f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports